import mutations from './mutations';
import actions from './actions';
import getters from './getters';

export default {
  state() {
    return {
      amount: 0
    };
  },
  mutations,
  actions,
  getters,
  namespaced: true,
};
